(() => {
  if (window.__FAJ_CONTRACT_OPTIONS_V1__) return;
  window.__FAJ_CONTRACT_OPTIONS_V1__ = true;

  const upsertHiddenInput = (form, name, value) => {
    let input = form.querySelector(`input[name="${name}"]`);

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }

    input.value = value || '';
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-fajco-open-booking]');
    if (!trigger) return;

    event.preventDefault();

    const serviceSection = document.querySelector('[data-fajsp]');
    const bookingForm = serviceSection?.querySelector(
      '[data-fajsp-external-booking-form]'
    );
    const bookingOpener = serviceSection?.querySelector(
      '[data-fajsp-open-booking]'
    );

    if (bookingForm && bookingOpener) {
      const option = trigger.dataset.contractOption?.trim() || '';
      const duration = trigger.dataset.contractDuration?.trim() || '';
      const agreement = trigger.dataset.contractEyebrow?.trim() || '';

      upsertHiddenInput(
        bookingForm,
        'contract_option',
        option
      );
      upsertHiddenInput(
        bookingForm,
        'contract_duration',
        duration
      );
      upsertHiddenInput(
        bookingForm,
        'contract_agreement_type',
        agreement
      );
      upsertHiddenInput(
        bookingForm,
        'enquiry_source',
        'contract-options-section'
      );

      const subjectInput = bookingForm.querySelector(
        'input[name="subject"]'
      );

      if (subjectInput) {
        const productTitle =
          bookingForm.querySelector(
            'input[name="service_product"]'
          )?.value || 'Service Product';

        const planText = [agreement, option, duration]
          .filter(Boolean)
          .join(' — ');

        subjectInput.value = planText
          ? `Contract Quote — ${planText} — ${productTitle}`
          : `Contract Quote — ${productTitle}`;
      }

      bookingOpener.click();
      return;
    }

    const fallbackUrl = trigger.dataset.fallbackUrl?.trim();

    if (fallbackUrl) {
      window.location.assign(fallbackUrl);
      return;
    }

    console.warn(
      'FAJ contract options: the shared service booking form was not found.'
    );
  });
})();
